module.exports = __webpack_public_path__ + "img/bottom-round-rectangle.95e4f30b.svg";